import {
  SlBreadcrumb
} from "./chunk.N2LA23P5.js";

// src/components/breadcrumb/breadcrumb.ts
var breadcrumb_default = SlBreadcrumb;
SlBreadcrumb.define("sl-breadcrumb");

export {
  breadcrumb_default
};
